export default {
  'pages.propertyAgent.title': 'Property Agent Management',
  'pages.propertyAgent.subTitle': 'Manage property agent information and accounts',
  'pages.propertyAgent.detailTitle': 'Agent Details',
  'pages.propertyAgent.basicInfo': 'Basic Information',
  'pages.propertyAgent.accountInfo': 'Account Information',
  'pages.propertyAgent.otherInfo': 'Other Information',
  'pages.propertyAgent.name': 'Agent Name',
  'pages.propertyAgent.namePlaceholder': 'Please enter agent name',
  'pages.propertyAgent.type': 'Agent Type',
  'pages.propertyAgent.typePlaceholder': 'Please select agent type',
  'pages.propertyAgent.phone': 'Phone',
  'pages.propertyAgent.phonePlaceholder': 'Please enter phone number',
  'pages.propertyAgent.email': 'Email',
  'pages.propertyAgent.emailPlaceholder': 'Please enter email',
  'pages.propertyAgent.username': 'Username',
  'pages.propertyAgent.usernamePlaceholder': 'Please enter username',
  'pages.propertyAgent.password': 'Password',
  'pages.propertyAgent.passwordPlaceholder': 'Please enter password',
  'pages.propertyAgent.confirmPassword': 'Confirm Password',
  'pages.propertyAgent.confirmPasswordPlaceholder': 'Please enter password again',
  'pages.propertyAgent.status': 'Status',
  'pages.propertyAgent.remark': 'Remark',
  'pages.propertyAgent.remarkPlaceholder': 'Please enter remark',
};
